import { useCallback, useEffect, useRef, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import type { Dispatch } from 'redux';

import { RootActions } from 'CorePackage/MainModule/types/RootActions';
import { getPlanIsLoadingHistory } from 'PlanPackage/MainModule/selectors/planSelectors';
import { Button } from 'UIPackage/MainModule/components/Button';
import { KnmCollapse } from 'KnmPackage/MainModule/components/KnmCollapse';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { Section } from 'UIPackage/FormModule/components/Section';
import { Row } from 'UIPackage/FormModule/components/Row';

import styles from './ErknmPlanHistory.module.scss';
import { changeKnoGetPlanHistoryChanges } from '../actions/ChangeKnoInPlanActions';
import { getHistoryChangesItems } from '../selectors/changeKnoInPlanSelectors';
import { IPlanKnoChangeHistoryItem } from './IPlanKnoChangeHistoryItem';
import { formatDate } from '../../CorePackage/MainModule/common/formatDate';
import { DATE_FORMAT_ISO_FNS, DATE_FORMAT_LONG_MINUTE_FNS } from '../../CorePackage/MainModule/constants/dateFormats';

const PAGE_SIZE = 10;

interface IErknmPlanHistoryProps {
  historyChangesItems: IPlanKnoChangeHistoryItem[];
}

const ErknmPlanHistoryWithoutStore = ({ historyChangesItems }: IErknmPlanHistoryProps) => {
  const dispatch = useDispatch<Dispatch<RootActions>>();

  const blockRef = useRef<HTMLDivElement>(null);
  const [itemsPage, setItemsPage] = useState<number>(0);
  const lastVisibleItemsNumber = (itemsPage + 1) * PAGE_SIZE;

  useEffect(() => {
    dispatch(changeKnoGetPlanHistoryChanges());
  }, [dispatch]);

  const handleLoadMoreButtonClick = useCallback(() => setItemsPage(prev => prev + 1), []);

  const isLoadMoreButtonVisible = historyChangesItems.length > lastVisibleItemsNumber;

  return (
    <Section title="История изменений" id="changePlanHistory">
      <div ref={blockRef} />

      {historyChangesItems.length > 0 ? (
        <Row>
          {historyChangesItems.map((knmPlanHistoryItem, index) => {
            if (index > lastVisibleItemsNumber - 1) {
              return null;
            }

            return (
              <KnmCollapse
                key={uuidv4()}
                title={`Обновлено - ${knmPlanHistoryItem.user?.fullName} (${
                  knmPlanHistoryItem.user?.username
                }) ${formatDate({
                  date: knmPlanHistoryItem.created,
                  dateFormat: DATE_FORMAT_LONG_MINUTE_FNS,
                  parseFormat: DATE_FORMAT_ISO_FNS,
                })} (МСК)`}
              >
                <>
                  <div className={styles.Patch} key={uuidv4()}>
                    Значение поля &quot;Номер заявки в СТП&quot; добавлено: {knmPlanHistoryItem.stpNumber}
                    <br />
                    Значение поля &quot;Номер плана&quot; добавлено: {knmPlanHistoryItem.planId}
                    <br />
                    Значение поля &quot;КНО&quot; добавлено: {knmPlanHistoryItem.knoName}
                  </div>
                </>
              </KnmCollapse>
            );
          })}
        </Row>
      ) : (
        <Row>Сведения отсутствуют</Row>
      )}

      {isLoadMoreButtonVisible && (
        <Button type="button" text="Показать еще" color="load" onClick={handleLoadMoreButtonClick} />
      )}
    </Section>
  );
};

const mapStateToProps = (state: IRootState) => ({
  isLoading: getPlanIsLoadingHistory(state),
  historyChangesItems: getHistoryChangesItems(state),
});

export const PlanKnoChangeHistory = connect(mapStateToProps)(ErknmPlanHistoryWithoutStore);
